.selectCurrencyModal {
  z-index: 5000;

  @media (min-width: 769px) {
    top: calc(100% + 0.5rem);
    min-width: 18rem;
    height: 25rem;
  }

  > .content {
    @media (min-width: 769px) {
      height: auto;
      max-height: 16rem;
    }
  }

  .currencyList {
    display: flex;
    position: relative;
    flex-direction: column;
    height: calc(100% + 2.5rem);
    min-height: 0;
    margin: -1.25rem;
  }
}
